import React from 'react';
import { BrandLogo } from './BrandLogo';
import { UserMenu } from './UserMenu';

/**
 * Slim top bar used during onboarding (and onboarding-scoped Settings).
 *
 * Keeps the user menu — Profile, Settings, Sign out, Delete Account —
 * reachable without exposing the full dashboard sidebar to a user whose
 * organization onboarding is not yet complete.
 */
export const OnboardingTopBar: React.FC = () => {
  return (
    <header
      aria-label="Onboarding top bar"
      className="flex h-14 w-full items-center justify-between border-b bg-background/95 px-4 sm:px-6"
    >
      <BrandLogo className="h-8" />
      <UserMenu />
    </header>
  );
};
